var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoTraitement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_191",
    "data-name": "Groupe 191",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.842,
    height: 55.342,
    viewBox: "0 0 36.842 55.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 36.842,
    height: 55.342,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_190",
    "data-name": "Groupe 190",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_248",
    "data-name": "Trac\\xE9 248",
    d: "M18.438,55.342q-.614,0-1.233-.04A18.566,18.566,0,0,1,.111,38.939a18.306,18.306,0,0,1,1.041-8.425,1.248,1.248,0,0,1,.168-.667l.4-.685a18.457,18.457,0,0,1,1.647-2.844L17.659,1.64l.026-.063a6.14,6.14,0,0,0,.239-.624A1.263,1.263,0,0,1,19.018.006a1.246,1.246,0,0,1,1.253.7l.371.789,14.908,28.4a1.244,1.244,0,0,1,.143.622A18.422,18.422,0,0,1,18.438,55.342M3.746,30.645a1.251,1.251,0,0,1-.08.3A15.841,15.841,0,0,0,2.6,38.671a16.04,16.04,0,0,0,14.77,14.136A15.921,15.921,0,0,0,33.178,30.944a1.261,1.261,0,0,1-.087-.356L19.156,4.043,5.5,27.62c-.019.033-.04.065-.062.1a15.96,15.96,0,0,0-1.474,2.545,1.107,1.107,0,0,1-.053.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_249",
    "data-name": "Trac\\xE9 249",
    d: "M28.093,49.4v8.016a.542.542,0,0,0,.542.541H36.3a.542.542,0,0,1,.541.542v1.24a.542.542,0,0,1-.541.542H28.635a.542.542,0,0,0-.542.542v8.094a.542.542,0,0,1-.542.541H26.157a.542.542,0,0,1-.542-.541V60.818a.542.542,0,0,0-.542-.542H17.405a.542.542,0,0,1-.542-.542v-1.24a.542.542,0,0,1,.542-.542h7.668a.542.542,0,0,0,.542-.541V49.4a.542.542,0,0,1,.542-.542h1.394a.542.542,0,0,1,.542.542",
    transform: "translate(-8.431 -24.426)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTraitement);
export default __webpack_public_path__ + "static/media/picto_traitement.995076970c8b3c83404cd84998358974.svg";
export { ForwardRef as ReactComponent };